import {
  faGaugeMax,
  faRocketLaunch,
  faSmile,
} from "@fortawesome/pro-regular-svg-icons"
import { GreyIconBox } from "component/w24/structure/GreyIconBox"
import { Localization } from "libs/localization/localization"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  className?: string
}

export const Benefits = (props: Props): JSX.Element => {
  return (
    <S_Benefits className={props.className}>
      <GreyIconBox
        icon={faSmile}
        title={Localization.BOX1_TITLE}
        description={Localization.BOX1_DESC}
      />
      <GreyIconBox
        icon={faGaugeMax}
        title={Localization.BOX2_TITLE}
        description={Localization.BOX2_DESC}
      />
      <GreyIconBox
        icon={faRocketLaunch}
        title={Localization.BOX3_TITLE}
        description={Localization.BOX3_DESC}
      />
    </S_Benefits>
  )
}

const S_Benefits = styled.div`
  display: flex;
  gap: 20px;
  @media only screen and (min-width: 1260px) {
    gap: 60px;
  }
`
